export const DATE_CONSTANTS = {
    timeZone: 'T02:00:00.000-07:00'
};
